import React from 'react'
import { telegramLinks } from 'config/constants/telegramLinks'
import Telegram from './networks/Telegram'
import Facebook from './networks/Facebook'
import Github from './networks/Github'
import Twitter from './networks/Twitter'
import CoinMarketCap from './networks/CoinMarketCap'
import CoinGecko from './networks/CoinGecko'
import GeckoTerminal from './networks/GeckoTerminal'

const SocialMediaLinks: React.FC = () => (
  <div className="flex gap-8">
    <Telegram items={telegramLinks} />
    <Facebook />
    <Twitter />
    <Github />
    <CoinMarketCap />
    <CoinGecko />
    <GeckoTerminal />
  </div>
)

export default SocialMediaLinks
